import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui";

const KEY = "wcrx_cookie_choice_v1";

/**
 * Cookie consent banner — defaults to ESSENTIAL ONLY per user privacy lock.
 * Choices stored in localStorage (NOT cookies — privacy-preserving).
 */
export function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const choice = window.localStorage.getItem(KEY);
      if (!choice) setOpen(true);
    } catch {
      /* SSR / restricted storage — render banner */
      setOpen(true);
    }
  }, []);

  function persist(choice: "essential" | "all") {
    try {
      window.localStorage.setItem(
        KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch {
      /* ignore */
    }
    setOpen(false);
  }

  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-labelledby="cookie-title"
      aria-describedby="cookie-desc"
      className="fixed inset-x-3 bottom-3 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 rounded-2xl bg-surface border border-border shadow-pop p-5"
    >
      <p id="cookie-title" className="text-sm font-semibold text-ink-900">
        We use only essential cookies.
      </p>
      <p id="cookie-desc" className="mt-2 text-sm text-ink-600">
        We use a minimal set of cookies to make this site work. We do not run
        third-party analytics or advertising trackers. Read our{" "}
        <Link to="/cookies" className="text-forest-700 underline">
          cookie policy
        </Link>{" "}
        for details.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button size="sm" onClick={() => persist("essential")}>
          Accept essential
        </Button>
        <Button size="sm" variant="ghost" onClick={() => persist("all")}>
          Accept all
        </Button>
      </div>
    </div>
  );
}
